import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=45cd49d7&scoped=true"
import script from "./Welcome.vue?vue&type=script&lang=js"
export * from "./Welcome.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/group_dashboard/welcome.css?vue&type=style&index=0&id=45cd49d7&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cd49d7",
  null
  
)

export default component.exports